import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconLightbulb = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" size={size} {...props}>
        <StyledStrokedGroup color={color} clipPath="url(#a)">
            <StyledPath
                color="none"
                strokeWidth="1.5px"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 1.876V.626M15.303 4.073l.884-.884M17.5 9.376h1.25M15.303 14.68l.884.883M4.697 4.073l-.885-.884M2.5 9.376H1.25M4.697 14.68l-.885.883M7.5 13.707v1.917a2.5 2.5 0 0 0 5 0v-1.917"
            />
            <StyledPath
                color="none"
                strokeWidth="1.5px"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 9.376a5 5 0 1 0 10 0 5 5 0 0 0-10 0v0ZM10 18.126v1.25"
            />
        </StyledStrokedGroup>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
        </defs>
    </StyledSvg>
);
